var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFF00;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,2C12.3,2,2,12.3,2,25s10.3,23,23,23s23-10.3,23-23S37.7,2,25,2z M36.2,20.5c0,0.2,0,0.5,0,0.7 c0,7.3-5.6,15.8-15.8,15.8c-3.1,0-6-0.9-8.5-2.5c0.4,0.1,0.9,0.1,1.3,0.1c2.6,0,5-0.9,6.9-2.4c-2.4,0-4.5-1.6-5.2-3.8 c0.3,0.1,0.7,0.1,1,0.1c0.5,0,1-0.1,1.5-0.2c-2.5-0.5-4.4-2.7-4.4-5.4c0,0,0,0,0-0.1c0.7,0.4,1.6,0.7,2.5,0.7 c-1.5-1-2.5-2.7-2.5-4.6c0-1,0.3-2,0.7-2.8c2.7,3.4,6.8,5.6,11.4,5.8C25,21.5,25,21.1,25,20.6c0-3.1,2.5-5.5,5.5-5.5 c1.6,0,3,0.7,4,1.7c1.3-0.2,2.4-0.7,3.5-1.3c-0.4,1.3-1.3,2.4-2.4,3.1c1.1-0.1,2.2-0.4,3.2-0.9C38.3,18.8,37.3,19.7,36.2,20.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.18d3d71db773808ce12b506037563210.svg";
export { ForwardRef as ReactComponent };